import { SvgBase } from "../svg.base";

export const RedError: React.FC<{ size?: number }> = ({ size }) => (
    <SvgBase
        width={"" + (size || 64)}
        height={"" + (size || 64)}
        viewBox="0 0 64 64"
    >
        <g fill="none" fillRule="evenodd">
        <g>
            <g transform="translate(-150 -64) translate(150 64)">
                <circle cx="32" cy="32" r="32" fill="#C62828" fillRule="nonzero"/>
                <g fill="#FFF">
                    <path d="M44.333 14.957L41.043 11.667 28 24.71 14.957 11.667 11.667 14.957 24.71 28 11.667 41.043 14.957 44.333 28 31.29 41.043 44.333 44.333 41.043 31.29 28z" transform="translate(2 4)"/>
                </g>
            </g>
        </g>
    </g>
    </SvgBase>
);


